export const OTHER_MENUS = [
  {
    _id: '663b01ee0d3a317839cb3633',
    component_content_id: '63806ca840b4a5aea422f089',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link_type: 1,
    sequence: 1,
    image_desktop_path: {
      'en-US': 'demo/games/other/image-1-en.png',
      'th-TH': 'demo/games/other/image-1-th.png',
      'zh-CN': 'demo/games/other/image-1-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/other/image-1-en-mobile.png',
      'th-TH': 'demo/games/other/image-1-th-mobile.png',
      'zh-CN': 'demo/games/other/image-1-ch-mobile.png'
    },
    __v: 0,
    image_path: {},
    link: {}
  },
  {
    _id: '6658048d20a51e926bd92be2',
    component_content_id: '63806ca840b4a5aea422f089',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link_type: 1,
    sequence: 2,
    __v: 0,
    image_path: {},
    link: {},
    image_desktop_path: {
      'en-US': 'demo/games/other/image-2-en.png',
      'th-TH': 'demo/games/other/image-2-th.png',
      'zh-CN': 'demo/games/other/image-2-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/other/image-2-en-mobile.png',
      'th-TH': 'demo/games/other/image-2-th-mobile.png',
      'zh-CN': 'demo/games/other/image-2-ch-mobile.png'
    }
  },
  {
    _id: '66582e0f59b3cc257cc71280',
    component_content_id: '63806ca840b4a5aea422f089',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link_type: 1,
    sequence: 3,
    __v: 0,
    image_desktop_path: {
      'en-US': 'demo/games/other/image-3-en.png',
      'th-TH': 'demo/games/other/image-3-th.png',
      'zh-CN': 'demo/games/other/image-3-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/other/image-3-en-mobile.png',
      'th-TH': 'demo/games/other/image-3-th-mobile.png',
      'zh-CN': 'demo/games/other/image-3-ch-mobile.png'
    },
    image_path: {},
    link: {}
  },
  {
    _id: '665d2b8a6f88dd88ed133674',
    component_content_id: '63806ca840b4a5aea422f089',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link_type: 1,
    sequence: 4,
    image_desktop_path: {
      'en-US': 'demo/games/other/image-4-en.png',
      'th-TH': 'demo/games/other/image-4-th.png',
      'zh-CN': 'demo/games/other/image-4-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/other/image-4-en-mobile.png',
      'th-TH': 'demo/games/other/image-4-th-mobile.png',
      'zh-CN': 'demo/games/other/image-4-ch-mobile.png'
    },
    image_path: {},
    link: {}
  },
  {
    _id: '665d904b6f88dd88ed133844',
    component_content_id: '63806ca840b4a5aea422f089',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link_type: 1,
    sequence: 5,
    image_desktop_path: {
      'en-US': 'demo/games/other/image-5-en.png',
      'th-TH': 'demo/games/other/image-5-th.png',
      'zh-CN': 'demo/games/other/image-5-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/other/image-5-en-mobile.png',
      'th-TH': 'demo/games/other/image-5-th-mobile.png',
      'zh-CN': 'demo/games/other/image-5-ch-mobile.png'
    },
    image_path: {},
    link: {}
  },
  {
    _id: '665d904b6f88dd88ed133841',
    component_content_id: '63806ca840b4a5aea422f089',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link_type: 1,
    sequence: 5,
    image_desktop_path: {
      'en-US': 'demo/games/other/image-5-en.png',
      'th-TH': 'demo/games/other/image-5-th.png',
      'zh-CN': 'demo/games/other/image-5-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/other/image-5-en-mobile.png',
      'th-TH': 'demo/games/other/image-5-th-mobile.png',
      'zh-CN': 'demo/games/other/image-5-ch-mobile.png'
    },
    image_path: {},
    link: {}
  }
]
